
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationTrunk from "../../decorations/jungle/DecorationTrunk";
import TrapMarkerSpikes from "../../editor/trap-markers/jungle/TrapMarkerSpikes";
import PlatformMarkerFoliage3 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage3";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import DecorationBranch from "../../decorations/jungle/DecorationBranch";
import SmashableMarkerVine from "../../editor/entity-markers/SmashableMarkerVine";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import PlatformMarkerFoliage4 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage4";
import PlatformFoliage1 from "../../platforms/jungle/PlatformFoliage1";
import PlatformFoliage2 from "../../platforms/jungle/PlatformFoliage2";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class JungleChunkHard1 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 341, y ?? 108);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 6056, 661);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -331, 661);
    this.add(editor_bounds_left);

    // trunk_png_1
    const trunk_png_1 = new DecorationTrunk(scene, 1965, 694);
    this.add(trunk_png_1);

    // trunk_png_2
    const trunk_png_2 = new DecorationTrunk(scene, -137, 809);
    this.add(trunk_png_2);

    // trunk_png
    const trunk_png = new DecorationTrunk(scene, 373, 705);
    this.add(trunk_png);

    // trunk_png_3
    const trunk_png_3 = new DecorationTrunk(scene, 4336, 528);
    this.add(trunk_png_3);

    // trapSpikesMarker
    const trapSpikesMarker = new TrapMarkerSpikes(scene, 3785, -534);
    this.add(trapSpikesMarker);

    // platformMarkerFoliage
    const platformMarkerFoliage = new PlatformMarkerFoliage3(scene, -141, 503);
    this.add(platformMarkerFoliage);

    // platformMarkerFoliage_1
    const platformMarkerFoliage_1 = new PlatformMarkerFoliage3(scene, 1962, 386);
    this.add(platformMarkerFoliage_1);

    // platformMarkerFoliage_2
    const platformMarkerFoliage_2 = new PlatformMarkerFoliage3(scene, 2500, 591);
    this.add(platformMarkerFoliage_2);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 3585, -274);
    this.add(gemMarker_11);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 3873, -222);
    this.add(megaGemMarker_2);

    // decorationBranch_1
    const decorationBranch_1 = new DecorationBranch(scene, 3709, 429);
    this.add(decorationBranch_1);

    // smashableMarkerVine
    const smashableMarkerVine = new SmashableMarkerVine(scene, 3778, -340);
    this.add(smashableMarkerVine);

    // platformMarkerFoliage4
    const platformMarkerFoliage4 = new PlatformMarkerFoliage4(scene, 3693, -134);
    this.add(platformMarkerFoliage4);

    // platformFoliage1
    const platformFoliage1 = new PlatformFoliage1(scene, 3787, -482);
    this.add(platformFoliage1);

    // platformFoliage2
    const platformFoliage2 = new PlatformFoliage2(scene, 377, 402);
    this.add(platformFoliage2);

    // platformFoliage
    const platformFoliage = new PlatformFoliage1(scene, 2373, 151);
    this.add(platformFoliage);

    // trunk_png_4
    const trunk_png_4 = new DecorationTrunk(scene, 744, 645);
    this.add(trunk_png_4);

    // trunk_png_5
    const trunk_png_5 = new DecorationTrunk(scene, 2488, 892);
    this.add(trunk_png_5);

    // platformFoliage_2
    const platformFoliage_2 = new PlatformFoliage1(scene, 2839, 464);
    this.add(platformFoliage_2);

    // decorationBranch_2
    const decorationBranch_2 = new DecorationBranch(scene, 3517, 426);
    decorationBranch_2.flipX = true;
    decorationBranch_2.flipY = false;
    this.add(decorationBranch_2);

    // trunk_png_6
    const trunk_png_6 = new DecorationTrunk(scene, 2843, 769);
    this.add(trunk_png_6);

    // trunk_png_7
    const trunk_png_7 = new DecorationTrunk(scene, 3614, 689);
    this.add(trunk_png_7);

    // platformMarkerFoliage_3
    const platformMarkerFoliage_3 = new PlatformMarkerFoliage4(scene, 3630, 375);
    this.add(platformMarkerFoliage_3);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 2377, 51);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 2492, 489);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 1941, 274);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 765, 230);
    this.add(gemMarker_3);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 363, 274);
    this.add(gemMarker_4);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 3653, 228);
    this.add(gemMarker_6);

    // platformMarkerFoliage_4
    const platformMarkerFoliage_4 = new PlatformMarkerFoliage4(scene, 4357, 220);
    this.add(platformMarkerFoliage_4);

    // trapSpikesMarker_1
    const trapSpikesMarker_1 = new TrapMarkerSpikes(scene, 4342, 138);
    this.add(trapSpikesMarker_1);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 4506, 127);
    this.add(megaGemMarker);

    // platformMarkerFoliage_5
    const platformMarkerFoliage_5 = new PlatformMarkerFoliage3(scene, 5604, 290);
    this.add(platformMarkerFoliage_5);

    // trunk_png_8
    const trunk_png_8 = new DecorationTrunk(scene, 5592, 595);
    this.add(trunk_png_8);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 5596, 188);
    this.add(gemMarker_7);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, -240, 465);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 3450, 304);
    this.add(checkpointMarker_1);

    // trapSpikesMarker_2
    const trapSpikesMarker_2 = new TrapMarkerSpikes(scene, 606, 267);
    this.add(trapSpikesMarker_2);

    // platformMarkerFoliage_6
    const platformMarkerFoliage_6 = new PlatformMarkerFoliage3(scene, 708, 325);
    this.add(platformMarkerFoliage_6);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 2903, -91);
    this.add(megaGemMarker_1);

    // platformMarkerFoliage_7
    const platformMarkerFoliage_7 = new PlatformMarkerFoliage4(scene, 3004, 0);
    this.add(platformMarkerFoliage_7);

    // trapSpikesMarker_3
    const trapSpikesMarker_3 = new TrapMarkerSpikes(scene, 3069, -66);
    this.add(trapSpikesMarker_3);

    // trapSpikesMarker_4
    const trapSpikesMarker_4 = new TrapMarkerSpikes(scene, 2849, 410);
    this.add(trapSpikesMarker_4);

    // trunk_png_9
    const trunk_png_9 = new DecorationTrunk(scene, 5240, 630);
    this.add(trunk_png_9);

    // trapSpikesMarker_5
    const trapSpikesMarker_5 = new TrapMarkerSpikes(scene, 5254, 262);
    this.add(trapSpikesMarker_5);

    // platformFoliage_1
    const platformFoliage_1 = new PlatformFoliage1(scene, 5253, 316);
    this.add(platformFoliage_1);

    // trunk_png_10
    const trunk_png_10 = new DecorationTrunk(scene, 4932, 689);
    this.add(trunk_png_10);

    // platformFoliage_3
    const platformFoliage_3 = new PlatformFoliage1(scene, 4945, 375);
    this.add(platformFoliage_3);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 4930, 273);
    this.add(gemMarker_5);

    // trapSpikesMarker_6
    const trapSpikesMarker_6 = new TrapMarkerSpikes(scene, 1416, 70);
    this.add(trapSpikesMarker_6);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 1216, 330);
    this.add(gemMarker_8);

    // megaGemMarker_3
    const megaGemMarker_3 = new MegaGemMarker(scene, 1504, 382);
    this.add(megaGemMarker_3);

    // smashableMarkerVine_1
    const smashableMarkerVine_1 = new SmashableMarkerVine(scene, 1409, 264);
    this.add(smashableMarkerVine_1);

    // platformMarkerFoliage_8
    const platformMarkerFoliage_8 = new PlatformMarkerFoliage4(scene, 1324, 470);
    this.add(platformMarkerFoliage_8);

    // platformFoliage_4
    const platformFoliage_4 = new PlatformFoliage1(scene, 1418, 122);
    this.add(platformFoliage_4);

    // trunk_png_11
    const trunk_png_11 = new DecorationTrunk(scene, 1292, 789);
    this.add(trunk_png_11);

    // platformFoliage_5
    const platformFoliage_5 = new PlatformFoliage1(scene, 3085, 474);
    this.add(platformFoliage_5);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 3089, 374);
    this.add(gemMarker_9);

    // decorationBranch
    const decorationBranch = new DecorationBranch(scene, 4438, 282);
    this.add(decorationBranch);

    // decorationBranch_3
    const decorationBranch_3 = new DecorationBranch(scene, 1388, 524);
    this.add(decorationBranch_3);

    // this (components)
    new ChunkBoundaries(this);

    // smashableMarkerVine (components)
    const smashableMarkerVineSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerVine);
    smashableMarkerVineSimpleBreakableBlocker.allowedCharacter = "ice";
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
